<template>
	<router-link :to="{ name: 'signout' }">Logout</router-link>
</template>

<script>
export default {};
</script>
